(function () {
    const PRODUCTS_LIST = '.rb-items-wrapper';
    const PRODUCT_ITEM = '.rb-item';
    const CLEAR_ALL_BUTTON = 'a.rb-filters-clear';

    const FILTERS_ROOT = '.rb-filters';
    const FILTER_OPTIONS_LIST = 'ul.rb-filter-list';
    const FILTER_OPTION_ITEM = 'li.rb-filter-item[data-rb-filter]';

    const sortedOptionLists = new WeakSet();

    let isInitialSortDone = false;
    let initialRenderObserver = null;
    let initAttemptsCount = 0;
    const MAX_INIT_ATTEMPTS = 30; // ~ 15s

    // Product order after the initial sort (array of data-rb-item-id)
    let initialSortedProductIds = null;

    function extractYearFromProduct(productEl) {
        const label = productEl.getAttribute('aria-label') || '';
        const match = label.match(/\b(19\d{2}|20\d{2})\b/);
        return match ? Number(match[1]) : -Infinity;
    }

    function getProductId(productEl) {
        return productEl.getAttribute('data-rb-item-id') || '';
    }

    function saveCurrentOrder(listEl) {
        const products = Array.from(listEl.querySelectorAll(PRODUCT_ITEM));
        const ids = products.map(getProductId).filter(Boolean);
        return ids.length ? ids : null;
    }

    function restoreOrderByIds(listEl, ids) {
        if (!Array.isArray(ids) || !ids.length) return false;

        const products = Array.from(listEl.querySelectorAll(PRODUCT_ITEM));
        if (!products.length) return false;

        const productMap = new Map(products.map((el) => [getProductId(el), el]));

        // Recharge has not finished rendering all products yet
        if (!ids.every((id) => productMap.has(id))) return false;

        const fragment = document.createDocumentFragment();
        ids.forEach((id) => fragment.appendChild(productMap.get(id)));

        products.forEach((el) => {
            const id = getProductId(el);
            if (!ids.includes(id)) fragment.appendChild(el);
        });

        listEl.appendChild(fragment);
        return true;
    }

    function sortProductsByYearDesc(listEl) {
        const products = Array.from(listEl.querySelectorAll(PRODUCT_ITEM));
        if (products.length < 2) return false;

        const hasAnyYear = products.some(
            (product) => extractYearFromProduct(product) !== -Infinity
        );
        if (!hasAnyYear) return false;

        // Newest → oldest
        products.sort(
            (a, b) => extractYearFromProduct(b) - extractYearFromProduct(a)
        );

        const fragment = document.createDocumentFragment();
        products.forEach((el) => fragment.appendChild(el));
        listEl.appendChild(fragment);

        return true;
    }

    // ---------- Options sorting (Vintage list) ----------
    function parseOptionValue(optionEl) {
        const raw = optionEl.getAttribute('data-rb-filter') || '';
        const n = Number(raw);
        return Number.isFinite(n) ? n : -Infinity;
    }

    function sortOptionsInListDesc(listEl) {
        if (!listEl || sortedOptionLists.has(listEl)) return;

        const items = Array.from(listEl.querySelectorAll(FILTER_OPTION_ITEM));
        if (items.length < 2) return;

        const hasNumeric = items.some((el) => parseOptionValue(el) !== -Infinity);
        if (!hasNumeric) return;

        items.sort((a, b) => parseOptionValue(b) - parseOptionValue(a)); // DESC

        const fragment = document.createDocumentFragment();
        items.forEach((el) => fragment.appendChild(el));
        listEl.appendChild(fragment);

        sortedOptionLists.add(listEl);
    }

    function sortAllVisibleOptions() {
        const lists = Array.from(document.querySelectorAll(FILTER_OPTIONS_LIST));
        lists.forEach((ul) => sortOptionsInListDesc(ul));
    }
    // -----------------------------------------------

    function runInitialSortOnce() {
        if (isInitialSortDone) return;

        const listEl = document.querySelector(PRODUCTS_LIST);
        if (!listEl) return;

        const sorted = sortProductsByYearDesc(listEl);
        if (sorted) {
            // Save product order after the initial sort
            initialSortedProductIds = saveCurrentOrder(listEl);
            isInitialSortDone = true;

            if (initialRenderObserver) {
                initialRenderObserver.disconnect();
            }
        }
    }

    // resort products by click
    function handleClearAllClick() {
        document.addEventListener('click', (event) => {
            const clearButton = event.target.closest(CLEAR_ALL_BUTTON);
            if (!clearButton) return;

            const label = (clearButton.textContent || '').trim().toLowerCase();
            if (label !== 'clear all') return;

            if (!initialSortedProductIds) return;

            let attempts = 0;
            const MAX_RESTORE_ATTEMPTS = 30;

            // Wait for Recharge to re-render the list, then restore initial order
            setTimeout(() => {
                const restoreTimer = setInterval(() => {
                    attempts += 1;

                    const listEl = document.querySelector(PRODUCTS_LIST);
                    if (listEl && restoreOrderByIds(listEl, initialSortedProductIds)) {
                        clearInterval(restoreTimer);
                        return;
                    }

                    if (attempts >= MAX_RESTORE_ATTEMPTS) {
                        clearInterval(restoreTimer);
                    }
                }, 100);
            }, 80);
        });
    }

    //resort products when user opens filters
    function handleFilterCheckboxChange() {
        document.addEventListener('change', (event) => {
            // Works for Recharge filter checkboxes
            const checkbox = event.target.closest('input[type="checkbox"]');
            if (!checkbox) return;

            const insideFilters = checkbox.closest(FILTERS_ROOT);
            if (!insideFilters) return;

            if (!initialSortedProductIds) return;

            let attempts = 0;
            const MAX_RESTORE_ATTEMPTS = 30;

            setTimeout(() => {
                const restoreTimer = setInterval(() => {
                    attempts += 1;

                    const listEl = document.querySelector(PRODUCTS_LIST);
                    // IMPORTANT: allow restoring even for a subset (see note below)
                    if (listEl && restoreOrderByIds(listEl, initialSortedProductIds)) {
                        clearInterval(restoreTimer);
                        return;
                    }

                    if (attempts >= MAX_RESTORE_ATTEMPTS) {
                        clearInterval(restoreTimer);
                    }
                }, 100);
            }, 80);
        });
    }

    //sort options when user opens filters (options are rendered lazily)
    function handleOptionsSortingOnFilterOpen() {
        document.addEventListener('click', (event) => {
            const insideFilters = event.target.closest(FILTERS_ROOT);
            if (!insideFilters) return;

            setTimeout(sortAllVisibleOptions, 0);
            setTimeout(sortAllVisibleOptions, 50);
        });
    }

    function init() {
        handleClearAllClick();
        handleFilterCheckboxChange();
        handleOptionsSortingOnFilterOpen();

        // Try immediately in case Recharge is already rendered
        runInitialSortOnce();
        sortAllVisibleOptions();

        initialRenderObserver = new MutationObserver(() => {
            if (!isInitialSortDone) {
                runInitialSortOnce();
            }

            sortAllVisibleOptions();
        });

        initialRenderObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Fallback polling in case observer does not fire
        const initTimer = setInterval(() => {
            if (isInitialSortDone || initAttemptsCount >= MAX_INIT_ATTEMPTS) {
                clearInterval(initTimer);
                if (!isInitialSortDone && initialRenderObserver) {
                    initialRenderObserver.disconnect();
                }
                return;
            }

            initAttemptsCount += 1;
            runInitialSortOnce();
        }, 150);
    }

    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', init)
        : init();
})();
